import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { PaletteSVG } from '@common_components/svg/palette.svg';

const PaletteIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <PaletteSVG />
    </div>
  );
};

export { PaletteIcon };
